import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import styles from "./footer.module.scss";
import logo from "../../../images/logo-explore.svg";
import x from "../../../images/x.svg";
import facebook from "../../../images/facebook.svg";
import youtube from "../../../images/youtube.svg";
import linkedin from "../../../images/linkedin.svg";
import instagram from "../../../images/instagram.svg";
import { handleScroll } from "../../../utils/scroll-helpers";
import { Link } from "react-router-dom";

const Footer: FC = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.wrapper}>
          <div className={styles.btns}>
            <a href="https://madayn.om">
              <button>{t("footer.backToMadayn")}</button>
            </a>
            <button onClick={() => handleScroll("solutions")}>
              {t("footer.discoverLocations")}
            </button>
            <button onClick={() => handleScroll("how-it-works")}>
              {t("footer.howItWorks")}
            </button>
          </div>
          <div className={styles.info}>
            <img
              className={styles.logo}
              width={200}
              height={96}
              src={logo}
              alt="logo"
            />
            <div className={styles.links}>
              <Link to="#">
                <img src={x} alt="x" />
              </Link>
              <Link to="#">
                <img src={facebook} alt="facebook" />
              </Link>
              <Link to="#">
                <img src={instagram} alt="instagram" />
              </Link>
              <Link to="#">
                <img src={youtube} alt="youtube" />
              </Link>
              <Link to="#">
                <img src={linkedin} alt="linkedin" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
